var prodcat = prodcat || {};
var site = site || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
site.util = site.util || {};
var selectedSkus;

(function ($) {
  $(document).on('change', '.js-shade-select-hidden', function () {
    var $skuMenuHidden = $(this);
    var selectedSkuBaseId = $skuMenuHidden.val();
    var $useItWithWrapper = $skuMenuHidden.closest('.js-use-it-with-atb-info');

    if ($useItWithWrapper.length === 0) {
      prodcat.ui.getProductEl($skuMenuHidden).trigger('product.skuSelect', selectedSkuBaseId);
    } else {
      $(document).trigger('useitwith.skuSelect', [selectedSkuBaseId, $useItWithWrapper]);
    }
  });

  $(document).on('change', '.js-second-shade-select-hidden', function () {
    var $skuMenuHidden = $(this);
    var selectedSkuBaseId = $skuMenuHidden.val();
    var hasDramming = true;

    prodcat.ui.getProductEl($skuMenuHidden).trigger('product.skuSelect', [selectedSkuBaseId, hasDramming]);
  });

  $(document).on('product.skuSelect', '.js-product', function (event, skuBaseId, hasDramming) {
    // don't execute only on init for dramming product
    if (hasDramming === 'noshade') {
      return;
    }
    var $skuMenuHidden = $('.js-shade-select-hidden', this);

    if (hasDramming) {
      $skuMenuHidden = $('.js-second-shade-select-hidden', this);
    }
    var $selects = $skuMenuHidden.parents('.js-shade-select');

    $skuMenuHidden.val(skuBaseId);
    if (Drupal.behaviors.productShadeSelectV1 && $selects.length) {
      $selects.each(function () {
        Drupal.behaviors.productShadeSelectV1.setOption($(this), skuBaseId, hasDramming);
      });
    }

    // Add the selected skus in kit
    var $product = $(this);

    if ($product.hasClass('js-product-dramming')) {
      var $addBtn = $('.js-add-to-cart', $(this));
      var firstskuBaseId = $('.js-shade-select-hidden').val();
      var secondskuBaseId = $('.js-second-shade-select-hidden').val();

      if (firstskuBaseId && secondskuBaseId) {
        var firstSkuDataL2 = prodcat.data.getSku(firstskuBaseId);
        var secondSkuDataL2 = prodcat.data.getSku(secondskuBaseId);

        if ((firstSkuDataL2 && firstSkuDataL2.isShoppable) && (secondSkuDataL2 && secondSkuDataL2.isShoppable)) {
          $addBtn.removeClass('button--disabled');
          $addBtn.data('disabled', false);
          selectedSkus = firstskuBaseId + ',' + secondskuBaseId;
          $addBtn.data('kit-skus', selectedSkus);
        }
      }
    }
  });

  $(document).on('product:quickshop:available', '.js-quickshop-container', function () {
    Drupal.behaviors.productShadeSelectV1.attach($(this));
  });

  Drupal.behaviors.productShadeSelectV1 = {
    attach: function (context) {
      var self = this;
      var $skuMenus = $('.js-shade-select', context);

      if (!$skuMenus.length) {
        return null;
      }
      $skuMenus.each(function () {
        self.init($(this));
      });
    },
    init: function ($skuMenu) {
      var $list = $('.js-shade-select-options', $skuMenu);
      var $name = $('.js-shade-select-option', $list);

      this.setLabel($skuMenu);
      this.setEvents($skuMenu);
    },
    setLabel: function ($select, hasDramming) {
      var $selected = $select.find('.js-shade-select-option.selected');
      // To remove, the selected option from first select box to second select box
      var selectedText;
      var selectedHex;
      var $skuHidden = $('.js-shade-select').find('.js-second-shade-select-hidden');

      if (hasDramming) {
        $skuHidden = $('.js-shade-select').find('.js-shade-select-hidden');
      }
      var $alternativeShade = $skuHidden.siblings('.js-shade-select-options').find('.js-shade-select-option');

      $alternativeShade.map(function (index) {
        if ($(this).data('shade-name') === $selected.data('shade-name')) {
          $(this).addClass('hidden');
        } else {
          $(this).removeClass('hidden');
        }
      });

      if (!$selected.length) {
        $selected = $select.find('.js-shade-select-option').first();
        selectedText = site.translations.product.spp_dramming_select_text;
        selectedHex = site.translations.product.spp_dramming_shade_color;
      } else {
        selectedText = $selected.find('.js-shade-select-label').html();
        selectedHex = $selected.find('.js-shade-select-color').data('hex-value');
      }
      $select.find('.js-shade-select-label-text').html(selectedText);
      $select.find('.js-shade-select-label-color').css('background-color', selectedHex);
    },
    setOption: function ($select, skuBaseId, hasDramming) {
      var $oldSelected = $select.find('.js-shade-select-option.selected');
      var $newSelected = $select.find('.js-shade-select-option[data-sku-base-id="' + skuBaseId + '"]');

      if ($newSelected.length) {
        $oldSelected
          .removeClass('selected')
          .attr('aria-selected', false);
        $newSelected
          .addClass('selected')
          .attr('aria-selected', true);
        this.setLabel($select, hasDramming);
      }
    },
    toggleOptions: function ($select) {
      var self = this;

      if (!$select.hasClass('js-shade-select-disabled')) {
        $select.toggleClass('open');
        if ($select.hasClass('open')) {
          $select.attr('aria-expanded', true);

          // Close the dropdown options when clicked outside of the select.
          $select.bind('clickoutside.shadeSelect', function () {
            self.closeOptions($(this));
          });
        } else {
          $select.attr('aria-expanded', false);
        }
      }
    },
    closeOptions: function ($select) {
      $select.removeClass('open');
      $select.unbind('clickoutside.shadeSelect');
    },
    closeAllSizeSelects: function () {
      $('.js-size-select.open').each(function () {
        $(this).removeClass('open').attr('aria-expanded', false).off('clickoutside.sizeSelect');
      });
    },
    orderAlphabetical: function ($list, $name) {
      $name.sort(function (a, b) {
        var aShade = $(a).data('shade-name');
        var bShade = $(b).data('shade-name');

        return aShade < bShade ? -1 : aShade > bShade ? 1 : 0;
      }).appendTo($list);
    },
    setEvents: function ($select) {
      var self = this;

      // Toggle visibility of dropdown.
      $select.once().on('click.shadeSelect', function (event) {
        event.stopPropagation();

        // Close all the other select dropdowns.
        $('.js-shade-select').not(this).each(function () {
          self.closeOptions($(this));
        });
        self.closeAllSizeSelects();

        // Toggle open the particular select that was clicked.
        $(this).find('.shade-select__label').addClass('custom-outline').focus();
        self.toggleOptions($(this));
      }).on('keydown.shadeSelect', function (e) {
        var $this = $(this);
        var $label = $this.find('.shade-select__label');
        var $option = $this.find('.js-shade-select-option.selected') || $this.find('.js-shade-select-option').first();
        var key = site.getKeycode(e);
        var $target = $(e.target);

        if (key === 13 && $target.hasClass('shade-select__label')) { // Enter
          e.stopPropagation();

          // Close all the other select dropdowns.
          $('.js-shade-select').not(this).each(function () {
            self.closeOptions($(this));
          });

          // Toggle open the particular select that was clicked.
          self.toggleOptions($(this));
          $label.removeClass('custom-outline');
          $option.addClass('custom-outline').focus();
        } else if (key === 27 || key === 9) { // Esc or Tab
          $option.removeClass('custom-outline');
          $label.addClass('custom-outline').focus();
          self.closeOptions($(this));
        }
      });

      // When an option is selected, put the value of the
      // old hidden select and update the label.
      $('.js-shade-select-option').bind('click', function () {
        var $this = $(this);
        var $select = $this.parents('.js-shade-select');
        var $hiddenClass = '.js-shade-select-hidden';
        var labelUpdate = false;

        if ($select.hasClass('js-check-dramming')) {
          $hiddenClass = '.js-second-shade-select-hidden';
          labelUpdate = true;
        }
        var $input = $select.find($hiddenClass);
        var $selected = $select.find('.js-shade-select-option.selected');

        $selected.removeClass('selected');
        $this.addClass('selected');
        $input.val($this.data('sku-base-id')).change();

        self.setLabel($select, labelUpdate);
      });
    }
  };
})(jQuery);
